module.exports = __webpack_public_path__ + "static/img/products_pu.2350f6fd.jpg";